module.exports = __webpack_public_path__ + "static/media/rectangle-copy-4.57ba0a82.png";